
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organizations/[organizationId]/upcoming-events",
      function () {
        return require("private-next-pages/organizations/[organizationId]/upcoming-events/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organizations/[organizationId]/upcoming-events"])
      });
    }
  